// extracted by mini-css-extract-plugin
module.exports = {"bigX":"InputField_bigX__28r32","dark":"InputField_dark__2vqej"};